import { Component, EventEmitter, Optional, Output} from '@angular/core';
import { AuthService } from "../../../../features/auth/services/auth.service";
import User from "../../../data/models/user.model";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-header',
    imports: [NgbModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Output() openMobileNav = new EventEmitter()

  user!: User

  constructor(@Optional() private auth: AuthService) {
    this.auth.userSubject.subscribe((user) => {
      this.user = user;
    });
  }

  get hasUser() {
    return !!this.auth.user;
  }

  get isClient() {
    return this.auth.isClient;
  }
}
